<template>
  <div class="row justify-center full-height full-width q-pa-md">
    <q-form class="q-gutter-md" @submit="onSubmit">
      <q-input v-model="username" filled label="Kullanici Adi" />

      <q-input v-model="password" filled type="password" label="Parola" />

      <div>
        <q-btn label="Giris" type="submit" color="primary" />
      </div>
    </q-form>
  </div>
</template>
<script>
import { useQuasar } from 'quasar'
import { ref } from 'vue'
import axios from 'axios'
import { useRouter } from 'vue-router'
import * as auth from '../plugins/auth'
import * as notify from '../utils/notification'
export default {
  setup() {
    const router = useRouter()
    const $q = useQuasar()
    const username = ref(null)
    const password = ref(null)

    auth.clearAuthentication()

    return {
      username,
      password,
      onSubmit() {
        axios
          .post(`/auth`, {
            username: username.value,
            password: password.value,
          })
          .then((response) => {
            if (response.status === 200) {
              auth.setToken(response.data)
              router.push('/')
              $q.notify(notify.success('Giris Basarili'))
            } else {
              $q.notify(notify.warning('Giris Basarisiz'))
            }
          })
          .catch((error) => {
            console.log(JSON.stringify(error))
          })
      },
    }
  },
}
</script>
